import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function ArticleHeader() {
  return <header className="mb-12" data-id="element-36">
      <FadeIn data-id="element-37">
        <h1 className="text-3xl md:text-4xl lg:text-[44px] font-extrabold text-[#111] text-center leading-tight mb-5 max-w-4xl mx-auto" data-id="element-38">
          Most Homeowners Overpay for Windows — This Quick Check Shows What You
          Should Really Pay
        </h1>

        <p className="text-lg md:text-xl text-[#444] text-center mb-8 max-w-2xl mx-auto" data-id="element-39">
          Takes less than 60 seconds. No calls required to start.
        </p>

        <div className="flex justify-center mb-6" data-id="element-40">
          <CTAButton data-id="element-41">Check Prices in My Area</CTAButton>
        </div>

        <p className="text-center text-sm text-[#666] italic mb-10" data-id="element-42">
          "Most people don't realize this pricing gap exists until it's too
          late."
        </p>

        <div className="w-full rounded-xl overflow-hidden shadow-sm" data-id="element-43">
          <img src="https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=1200&q=80" alt="Workers installing a large window on a white suburban house" className="w-full h-auto object-cover max-h-[480px]" loading="eager" data-id="element-44" />
        </div>
      </FadeIn>
    </header>;
}